import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {breakpoints} from "@next/themes"

interface TileCardBrandNameProps {
    $singleLineBrandName?: boolean
    $marginBottom?: boolean
}

export const TileCardBrandName = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<TileCardBrandNameProps>`
    margin-bottom: ${({$marginBottom}) => ($marginBottom ? "0.875rem" : "0")};
    overflow-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({$singleLineBrandName}) => ($singleLineBrandName ? "nowrap" : "normal")};
    display: ${({$singleLineBrandName}) => ($singleLineBrandName ? "block" : "-webkit-box")};
    font-size: ${({theme: {colours}}) => colours.typography.subtitle2.fontSize};
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.regular.weight};
    letter-spacing: ${({theme: {colours}}) => colours.typography.subtitle2.letterSpacing};
    -webkit-line-clamp: ${({$singleLineBrandName}) => ($singleLineBrandName ? 1 : 2)};
    -webkit-box-orient: vertical;
    @media (max-width: ${breakpoints.values.lg - 0.02}px) {
        white-space: normal;
        -webkit-line-clamp: ${({$singleLineBrandName}) => ($singleLineBrandName ? 1 : 2)};
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }
`

export default TileCardBrandName
